import styled from 'styled-components';
import { useParams } from 'react-router-dom';
import { useWorkspaces } from '../providers/WorkspaceProvider';

// Solo visible en mobile/tablet: en desktop el sidebar es fijo y no hace falta
// una barra superior. En ≤tablet aparece con la hamburguesa para abrir el menú.
const HeaderWrapper = styled.header`
  display: none;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.lg};
  background-color: ${({ theme }) => theme.colors.surface};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  min-height: 48px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: flex;
  }
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.md};
  min-width: 0;
`;

const MenuButton = styled.button`
  display: none;
  padding: ${({ theme }) => theme.spacing.sm};
  background: transparent;
  border: none;
  color: ${({ theme }) => theme.colors.text};
  border-radius: ${({ theme }) => theme.borderRadius.md};

  &:hover {
    background-color: ${({ theme }) => theme.colors.surfaceHover};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    display: flex;
  }
`;

export function Header({ onMenuClick }: { onMenuClick: () => void }) {
  const { workspaceId } = useParams();
  const { workspaces } = useWorkspaces();

  const currentWorkspace = workspaceId ? workspaces.find((w) => w.id === workspaceId) : null;

  return (
    <HeaderWrapper>
      <HeaderLeft>
        <MenuButton aria-label="Toggle menu" onClick={onMenuClick}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M3 12h18M3 6h18M3 18h18" />
          </svg>
        </MenuButton>
        {currentWorkspace && (
          <span style={{ fontSize: 13, color: '#64748B' }}>
            {currentWorkspace.name}
          </span>
        )}
      </HeaderLeft>
    </HeaderWrapper>
  );
}
